"use client";

import { TerminalIcon } from "lucide-react";

import type {
  ServerToolUseContentBlock,
  ToolUseContentBlock,
} from "../../types";
import { truncate } from "../../utils";
import { CollapsibleSection } from "../CollapsibleSection";

import { ToolCallDisplay } from "./ToolCallDisplay";

interface ToolUseBlockProps {
  block: ToolUseContentBlock;
  isStreaming?: boolean;
}

export const ToolUseBlock = ({ block, isStreaming }: ToolUseBlockProps) => (
  <ToolCallDisplay
    name={block.name}
    rawArgs={JSON.stringify(block.input)}
    isStreaming={isStreaming}
  />
);

interface ServerToolUseBlockProps {
  block: ServerToolUseContentBlock;
  isStreaming?: boolean;
}

function formatServerToolInput(input: Record<string, unknown>): string {
  return Object.entries(input)
    .map(
      ([key, value]) =>
        `${key}: ${typeof value === "string" ? value : JSON.stringify(value)}`,
    )
    .join("\n");
}

export const ServerToolUseBlock = ({
  block,
  isStreaming,
}: ServerToolUseBlockProps) => {
  const formatted = formatServerToolInput(block.input);
  return (
    <CollapsibleSection
      icon={<TerminalIcon className="h-3 w-3" />}
      label={block.name}
      preview={truncate(formatted)}
      copyContent={formatted}
      isStreaming={isStreaming}
    >
      <pre className="overflow-x-auto whitespace-pre-wrap break-words rounded-md bg-zinc-100 p-2 text-xs text-zinc-800">
        {formatted}
      </pre>
    </CollapsibleSection>
  );
};
